import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Hero } from "@/components/sections/Hero";
import { About } from "@/components/sections/About";
import { NaturalDiamonds } from "@/components/sections/Expertise";
import { Sourcing } from "@/components/sections/Transformation";
import { PreciousStones } from "@/components/sections/Collection";
import { Certification } from "@/components/sections/Certification";
import { WhyChoose } from "@/components/sections/WhyChoose";
import { InquiryForm } from "@/components/sections/InquiryForm";

export default function HomePage() {
  const { hash } = useLocation();

  // Smooth-scroll to anchor when arriving via a hash link from another page.
  useEffect(() => {
    if (!hash) return;
    const id = hash.replace("#", "");
    // Wait for next frame so the section is mounted.
    requestAnimationFrame(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  }, [hash]);

  return (
    <main>
      <Hero />
      <About />
      <NaturalDiamonds />
      <Sourcing />
      <PreciousStones />
      <Certification />
      <WhyChoose />
      <InquiryForm />
    </main>
  );
}
